import { render, staticRenderFns } from "./AboutAudio.vue?vue&type=template&id=377df95b&scoped=true&"
import script from "./AboutAudio.vue?vue&type=script&lang=js&"
export * from "./AboutAudio.vue?vue&type=script&lang=js&"
import style0 from "./AboutAudio.vue?vue&type=style&index=0&id=377df95b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377df95b",
  null
  
)

export default component.exports